import { defaultTheme as baseTheme, DefaultThemeType } from '@sunbit-dev/purchase-common/src/theme/defaultTheme';

export const defaultTheme: DefaultThemeType = {
  ...baseTheme,
  colors: {
    ...baseTheme.colors,
    tintPrimary235: '#7991FF',
  },
};
